module.exports = __webpack_public_path__ + "img/IMG_1908.ec14f668.jpg";